module.exports = __webpack_public_path__ + "img/bolotina.ed97da9d.jpg";